import React from 'react';
import { Button as AntDButton, ButtonProps, Space } from 'antd';
import { useT } from 'hooks/Locale/useT';
import './styles.scss';

type Base = Partial<ButtonProps>;

export interface ButtonInterface extends Omit<Base, 'type'> {
    type?: ButtonProps['type'] | 'outline';
    className?: string;
    disabled?: boolean;
    icon?: string;
    message: string;
}

const Button: React.FC<ButtonInterface> = ({
    className,
    type,
    disabled,
    icon,
    message,
    ...props
}) => {
    let buttonClassName = '';

    const t = useT();
    const messageId = message || 'button.default';

    switch (type) {
        case 'primary':
            buttonClassName = 'primary-button ';
            break;
        case 'outline':
            buttonClassName = 'outlined-button ';
            break;
        case 'dashed':
            buttonClassName = 'dashed-button ';
            break;
        case 'link':
            buttonClassName = 'link-button ';
            break;
    }

    return (
        <AntDButton {...props} className={buttonClassName + (className || '')} disabled={disabled}>
            <Space size={4}>
                {icon ? <i className={icon} /> : undefined}
                {t(messageId)}
            </Space>
        </AntDButton>
    );
};

export default Button;
